import { NotificationStore, NotificationStoreContext } from "csi/service/NotificationStore";
import { NotificationNode } from "csi/service/notificationService";
import { ICache } from "csi/typings";
import { useLocalStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import React, { FunctionComponent } from "react";
import Dropdown from "./Dropdown";

export interface DropdownWrapperProps {
	elem: HTMLElement;
	cache: ICache;
	notifications: NotificationNode[];
}

export const DropdownWrapper: FunctionComponent<DropdownWrapperProps> = (props) => {
	const { elem, cache } = props;
	const loc = useLocale();
	const store = useLocalStore(() => new NotificationStore(elem, cache, loc));

	return (
		<>
			{store && (
				<NotificationStoreContext.Provider value={store}>
					<Dropdown />
				</NotificationStoreContext.Provider>
			)}
		</>
	);
};

export default DropdownWrapper;